import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useIsMobileDimension } from "../hooks/useGetDimensionGroup";
import { TabsView } from "./components/TabsView";
export var Tabs = /*#__PURE__*/memo(function (_ref) {
  var tabs = _ref.tabs,
    selectedTab = _ref.selectedTab,
    onChange = _ref.onChange,
    variant = _ref.variant,
    isUpperCase = _ref.isUpperCase,
    noWrap = _ref.noWrap,
    testName = _ref.testName,
    isScrollable = _ref.isScrollable,
    isVertical = _ref.isVertical,
    outerSpaceValue = _ref.outerSpaceValue,
    onTabView = _ref.onTabView;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    focusedId = _useState2[0],
    setFocusedId = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isMobile = _useState4[0],
    setIsMobile = _useState4[1];
  var isMobileDimension = useIsMobileDimension();
  useEffect(function () {
    if (outerSpaceValue && isMobileDimension) {
      setIsMobile(true);
    }
  }, [outerSpaceValue, isMobileDimension]);
  var handleTabBlur = useCallback(function (id) {
    if (id === focusedId) {
      setFocusedId('');
    }
  }, [focusedId]);
  var handleTabFocus = useCallback(function (id) {
    setFocusedId(id);
  }, []);
  return /*#__PURE__*/React.createElement(TabsView, {
    focusedId: focusedId,
    isScrollable: isScrollable,
    isUpperCase: isUpperCase,
    isVertical: isVertical,
    noWrap: noWrap,
    onChange: onChange,
    onTabBlur: handleTabBlur,
    onTabFocus: handleTabFocus,
    onTabView: onTabView,
    outerSpaceValue: isMobile && outerSpaceValue ? Math.abs(outerSpaceValue) : undefined,
    selectedTab: selectedTab,
    tabs: tabs,
    testName: testName,
    variant: variant,
    "data-t-id": "src-Tabs"
  });
});
Tabs.displayName = Tabs.name;